export function isHealRoute(pathname: string): boolean {
  return (pathname.replace(/\/+$/, '') || '/').toLocaleLowerCase() === '/heal'
}
